<script setup lang="ts">
import { ArrowUpRight } from "@lucide/vue";
import { RouterLink } from "vue-router";
</script>

<template>
  <footer class="site-footer">
    <div class="footer-inner">
      <div class="footer-brand">
        <img src="/vpscope-mark.svg" alt="" width="34" height="34" />
        <div><strong>VPScope</strong><p>技术知识与在线工具</p></div>
      </div>
      <div class="footer-columns">
        <div><strong>知识库</strong><RouterLink to="/library?section=knowledge&topic=linux">Linux / 系统</RouterLink><RouterLink to="/library?section=knowledge&topic=network">网络 / 安全</RouterLink><RouterLink to="/library?section=knowledge&topic=troubleshoot">故障排查</RouterLink></div>
        <div><strong>工具资源</strong><RouterLink to="/tools/cidr">CIDR 规划器</RouterLink><RouterLink to="/tools/json-yaml">JSON / YAML</RouterLink><RouterLink to="/tools/time">时间转换</RouterLink><RouterLink to="/tools">已验证入口</RouterLink></div>
        <div><strong>VPS</strong><RouterLink to="/entry/vpsknow-6e7ffd3e02906434f49cf122">选择方法</RouterLink><RouterLink to="/library?section=reviews">历史测评</RouterLink><RouterLink to="/library?section=knowledge&q=路由">网络 / 路由</RouterLink></div>
        <div><strong>关于</strong><RouterLink to="/about">状态与方法</RouterLink><RouterLink to="/library?section=resources">资源导航</RouterLink></div>
      </div>
      <RouterLink class="footer-about" to="/about">关于本站 <ArrowUpRight :size="15" /></RouterLink>
      <div class="footer-meta">
        <p class="footer-note">公开内容以当前可复核证据为边界，价格、库存和线路结论请按文章日期重新核对。</p>
        <div class="footer-legal" aria-label="站点所有权与政策">
          <p>© 2026 VPScope. 保留所有权利。</p>
          <div><RouterLink to="/about#editorial-policy">编辑原则</RouterLink><RouterLink to="/about#privacy">隐私边界</RouterLink></div>
        </div>
      </div>
    </div>
  </footer>
</template>
